<template>
  <div class="list__item flex items-baseline leading-normal px-6 space-x-6">
    <div class="flex-1 py-5 text-center">Nothing to see yet!</div>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    selectable: Boolean,
    actionable: Boolean,
  },
};
</script>
